import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./whatsapp.module.scss";

const SUPPORT_PHONE = "77084857101";

const BrandedChannelCollapsedCTA = ({ info }) => {
  const { t } = useTranslation();

  const branchName = info?.name || "";
  const branchID = info?._id || info?.id || "";
  const idPart = branchID ? ` (id ${branchID})` : "";
  const prefill = encodeURIComponent(
    `${t("NSWhatsapp.brandedCtaSupportPrefill")} ${branchName}${idPart}`.trim()
  );
  const href = `https://wa.me/${SUPPORT_PHONE}?text=${prefill}`;

  return (
    <section className={styles.brandedCollapsed}>
      <div className={styles.brandedCollapsedText}>
        <h3>{t("NSWhatsapp.brandedCtaTitle")}</h3>
        <p>{t("NSWhatsapp.brandedCtaDesc")}</p>
      </div>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.chatSectionCta}
      >
        {t("NSWhatsapp.brandedCtaButton")}
      </a>
    </section>
  );
};

export default BrandedChannelCollapsedCTA;
